module.exports = __webpack_public_path__ + "img/mobile.59681d58.svg";